// @flow
import * as React from 'react';
import { Button } from 'primereact/button';
import { Alert } from 'reactstrap';
import { ProgressBar } from 'primereact/progressbar';
import moment from 'moment';
import { useAuth0 } from "../../../auth/react-auth0-wrapper";
import Can from "../../../auth/Can";
import roles from "../../../auth/roles";

export function LockTestCommand({
    command,
    deviceId,
    trigger,
    step,
    triggerNextStep
}) {

    const [loading, setLoading] = React.useState(false);
    const { gisApi } = useAuth0();

    const label = command === 'lock' ? 'BLOCCA' : 'SBLOCCA';
    const title = command === 'lock' ? 'blocco' : 'sblocco';
    const icon = command === 'lock' ? 'fas fa-lock' : 'fas fa-unlock-alt';
    const commandData = command === 'lock' ? 'setdigout 11' : 'setdigout 00';
    const completed = step.value && step.value.completed;
    const error = step.value && step.value.error;

    async function execCommand() {
        setLoading(true);
        const commandTime = moment().toJSON();

        const result = await gisApi.sendComand(
            deviceId,
            commandData,
            `test collaudo ${commandData}`,
            false
        );
        setLoading(false);
        if (result) {
            triggerNextStep({
                trigger: trigger,
                value: { completed: true, command: result, timestamp: commandTime }
            });
        } else {
            triggerNextStep({
                trigger: step.id,
                value: {
                    error:
                        `Errore invio comando (probabile errore di rete). Si prega di riprovare.`,
                    timestamp: commandTime

                }
            });
        }
    }

    return (
        <div>
            <Alert
                color={error ? 'danger' : completed ? 'success' : 'info'}
                title={`Esecuzione comando di ${title}`}

            >
                <div>
                    {loading && (
                        <div>
                            <ProgressBar className="mb-2" mode="indeterminate" style={{ height: '8px' }} />
                        </div>
                    )}
                    <div className="mb-2">
                        {
                            error ||
                            (completed
                                ? 'Comando inviato.'
                                : 'Premere per eseguire il comando.')
                        }
                    </div>
                    {!completed && !error && (
                        <div>
                            <Button
                                disabled={loading}
                                label={label}
                                icon={icon}
                                onClick={execCommand}
                                className={`p-button-info p-button-rounded`}
                            />

                            <Can
                                roles={[roles.ADMIN]}
                                yes={() =>
                                    <Button
                                        className="p-button-danger p-button-rounded ml-2"
                                        label={'FORZA TEST'}
                                        icon="fas fa-fast-forward"
                                        onClick={async () => {
                                            if (confirm('Confermi di voler forzare il test del ' + title + '?')) {
                                                triggerNextStep({
                                                    trigger: 'test-blocco-end',
                                                    value: { skipped: true, completed: true, timestamp: moment().toJSON() }
                                                });
                                            }
                                        }}
                                    />
                                }
                                no={() => null}
                            />
                        </div>
                    )}
                </div>
            </Alert>
        </div>
    );
}

export function LockTestCommandVerify({
    verify,
    deviceId,
    trigger,
    step,
    previousStep,
    triggerNextStep
}) {
    const [loading, setLoading] = React.useState(true);
    const { eventBus } = useAuth0()

    const title = verify === 'lock' ? 'blocco' : 'sblocco';
    const completed = step.value && step.value.completed;
    const error = step.value && step.value.error;
    const timestamp = previousStep.value && previousStep.value.timestamp;

    function verifyCommand(comandResult) {
        const lockedLambda = (res) => (res.startsWith('DOUT1:1') || res.startsWith('DOUT1:SCENARIO DOUT2:1') || res.startsWith('DOUTS are set to: 1100 TMOs are: 0 0 0 0. DOUT scenarios configured: 0000'));
        const unLockedLambda = (res) => (res.startsWith('DOUT1:0') || res.startsWith('DOUT1:SCENARIO DOUT2:0') || res.startsWith('DOUTS are set to: 0000 TMOs are: 0 0 0 0. DOUT scenarios configured: 0000'));
        const shouldStartWith = verify === 'lock' ? () => lockedLambda : unLockedLambda;
        if (shouldStartWith(comandResult.attributes.result)) {
            triggerNextStep({
                trigger: trigger,
                value: { completed: true, result: comandResult, timestamp: moment().toJSON() }
            });
        } else {
            triggerNextStep({
                trigger: previousStep.id,
                value: {
                    error:
                        `Test fallito. Rilevato: ${
                        verify === 'lock'
                            ? 'sblocco'
                            : 'blocco'
                        }, atteso: ${verify === 'lock' ? 'blocco' : 'sblocco'}`, timestamp: moment().toJSON()

                }
            });
        }
    }

    React.useEffect(() => {
        if (completed || error) return;

        const onCommandResult = (e) => {
            const payload = e.detail;
            const res = payload.position.attributes.result;
            const commandTimestamp = moment(timestamp);
            const deviceTime = moment(payload.position.deviceTime);
            if (res.startsWith('DOUT') || res.startsWith('DOUTS')) {
                // rimosso perchè non esegue la verifica del comando per Time diversi e invertiti
                // && commandTimestamp.isBefore(deviceTime)
                verifyCommand(payload.position);
                eventBus.removeEventListener("GISRESULT", onCommandResult);
                setLoading(false);
            }
        }

        eventBus.addEventListener("GISRESULT", onCommandResult);

        return function cleanup() {
            eventBus.removeEventListener("GISRESULT", onCommandResult);
        };
    }, []);

    return (
        <div>
            <Alert
                color={error ? 'danger' : completed ? 'success' : 'info'}
                title={`Verifica stato di ${title}`}

            ><div>
                    {loading && !error && !completed && (
                        <div>
                            <div className="mb-2">
                                {
                                    `Si prega di attendere. La verifica potrebbe richiedere alcuni secondi...`
                                }
                            </div>
                            <ProgressBar className="mb-2" mode="indeterminate" style={{ height: '8px' }} />
                        </div>
                    )}
                    {error && <div>{error}</div>}
                    {completed && <div>{`Stato di ${title} verificato correttamente`}</div>}
                </div></Alert>
        </div>
    );
}
